import { useRouter } from 'next/router';
import React, { ReactNode, useEffect } from 'react';

import { useIsMobile } from '@sravni/react-utils';

import styles from './overlay.module.scss';

interface IProps {
  children: ReactNode;
  overlaying: boolean;
  toggleOverlay: (value: 'on' | 'off') => void;
}

export const Overlay = ({ children, overlaying, toggleOverlay }: IProps) => {
  const { asPath } = useRouter();
  const isMobile = useIsMobile();

  const isSearchPage = asPath.includes('/search');

  useEffect(() => {
    if (!isSearchPage && isMobile) {
      window.scrollTo({ top: 68 });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.wrapper}>
      {children}
      {overlaying && <div className={styles.overlay} onClick={() => toggleOverlay('off')} />}
    </div>
  );
};
